import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MaterialModule } from '../../../@fury/shared/material-components.module';
import { ScrollbarModule } from '../../../@fury/shared/scrollbar/scrollbar.module';
import { AvatarDisplayModule } from '../../modules/avatar/avatar-display/avatar-display.module';
import { PipesModule } from './../../pipes/pipes.module';
import { SidenavItemComponent } from './sidenav-item/sidenav-item.component';
import { SidenavComponent } from './sidenav.component';
import { SidenavNavigationData } from './sidenav.data';
import { SidenavService } from './sidenav.service';
import { ReportModule } from 'src/app/modules/reports/report.module';

@NgModule({
  imports: [CommonModule, RouterModule, MaterialModule, ScrollbarModule, PipesModule, AvatarDisplayModule, ReportModule],
  declarations: [SidenavComponent, SidenavItemComponent],
  exports: [SidenavComponent],
  providers: [SidenavNavigationData, SidenavService]
})
export class SidenavModule {}
